<template lang="html">
    <nav class="app-nav">
        <div class="app-logo">
            <img src="../../assets/img/logo_s_white.svg" />
        </div>
        <router-link :to="{ name: 'projects' }">
            <v-icon>folder</v-icon>
        </router-link>
        <router-link :to="{ name: 'products-group' ,params:{group:groups[0].label} }">
          <i class="icon consumable"></i>
        </router-link>
        <router-link :to="{ name: 'products-group' ,params:{group:groups[1].label} }">
          <i class="icon equipment"></i>
        </router-link>
        <router-link :to="{ name: 'products-group' ,params:{group:groups[2].label} }">
          <i class="icon accessory"></i>
        </router-link>
        <router-link :to="{ name: 'list-symbols' }">
          <i class="icon symbol"></i>
        </router-link>

        <p class="version">V1</p>
    </nav>
</template>

<script>
    import {Groups} from '../../config/enum/Groups'

    export default {
        computed : {
            groups: function(){
              return Groups;
            }
        }
    }
</script>

<style lang="stylus" scoped>
    @require '../../assets/css/variables'

    nav.app-nav {
        display: flex
        flex-direction: column
        flex: none
        height: $app-nav-height
        width: $app-nav-width
        background: $app-nav-background
        z-index: 2

        div.app-logo {
            height: $app-nav-width
            display: flex
            align-items:center
            justify-content:center
            background-color: $primary-color

            img {
                max-width: 100%
            }
        }

        a {
            display: flex
            justify-content: center
            align-content: center
            height: $app-nav-width
            color: $app-nav-link-color
            text-decoration: none
            border-bottom: 1px solid #E7EAEF

            &:first-of-type {
                margin-top: 10rem
                border-top: 1px solid #E7EAEF
            }

            i.icon {
                font-size: 2rem
                color: $app-nav-link-color

              &.consumable, &.equipment, &.symbol, &.accessory {
                width:2rem
                height:2rem
                margin:auto
                background-color: $app-nav-link-color
              }

              &.consumable {
                mask: url(../../assets/img/icon_consumable.svg) no-repeat 50% 50%;
                -webkit-mask: url(../../assets/img/icon_consumable.svg) no-repeat 50% 50%;
              }

              &.equipment {
                mask: url(../../assets/img/icon_equipment.svg) no-repeat 50% 50%;
                -webkit-mask: url(../../assets/img/icon_equipment.svg) no-repeat 50% 50%;
              }

              &.symbol {
                mask: url(../../assets/img/icon_symbol.svg) no-repeat 50% 50%;
                -webkit-mask: url(../../assets/img/icon_symbol.svg) no-repeat 50% 50%;
              }

              &.accessory {
                mask: url(../../assets/img/icon_accessory.svg) no-repeat 50% 50%;
                -webkit-mask: url(../../assets/img/icon_accessory.svg) no-repeat 50% 50%;
              }
            }
            &.router-link-active {
                background-color: #F6FAFF
                border-left: 3px solid $app-nav-link-active-color
                i.icon {
                    color: $app-nav-link-active-color

                    &.equipment, &.consumable, &.symbol, &.accessory {
                      background-color: $app-nav-link-active-color
                    }

                }

            }
        }
        .version {
            position: absolute
            bottom: 0
            margin: 0
            width: $app-nav-width
            text-align: center
        }
    }
</style>



// WEBPACK FOOTER //
// src/layouts/app/Nav.vue